import { SPECIAL_DATE_TYPE } from '../../util/constants';

export const isAHoliday = (type: string): boolean => {
  return [SPECIAL_DATE_TYPE.PUBLIC_HOLIDAY, SPECIAL_DATE_TYPE.CLUEY_HOLIDAY].includes(type.toLowerCase());
};
